<template>
  <div>
    <Navbar v-if="$route.meta.navbar"/>
    <Breadcrumb v-if="$route.meta.navbar" />
    <div class="col-12 px-0 mx-0 mt-2">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 0}"
            @click="activeTab = 0"
            type="button"
          >
            <fa-icon name="file-import" /><br>Legacy Import
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 1}"
            @click="activeTab = 1"
            type="button"
          >
            <fa-icon class="me-2" name="clipboard-list" /><br>Access Log
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 2}"
            @click="activeTab = 2"
            type="button"
          >
            <fa-icon class="me-2" name="globe" /><br>Get Browser
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 3}"
            @click="activeTab = 3"
            type="button"
          >
            <fa-icon class="me-2" name="search" /><br>Track survey member
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 4}"
            @click="activeTab = 4"
            type="button"
          >
            <fa-icon class="me-2" name="wrench" /><br>Generate test data
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 5}"
            @click="activeTab = 5"
            type="button"
          >
            <fa-icon class="me-2" name="clipboard-list" /><br>Checklist
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 6}"
            @click="activeTab = 6"
            type="button"
          >
            <fa-icon class="me-2" name="list" /><br>Add-on-surveys
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 7}"
            @click="activeTab = 7"
            type="button"
          >
            <fa-icon class="me-2" name="file-excel" /><br>Add-on Export
          </button>
        </li>
      </ul>
      <div class="tab-content mt-3">
        <div v-if="activeTab === 0" class="tab-pane show active">
          <div class="border-0 mx-auto px-0 col-12">
            <ConsultantLegacyImport />
          </div>
        </div>
        <div v-if="activeTab === 1" class="tab-pane show active">
          <div class="border-0 mx-auto px-0 col-12">
            <Maintenance tablename="g_accesslog" />
          </div>
        </div>
        <div v-if="activeTab === 2" class="tab-pane show active">
          <div class="border-0 mx-auto px-0 col-12">
            <GetBrowser />
          </div>
        </div>
        <div v-if="activeTab === 3" class="tab-pane show active">
          <div class="border-0 mx-auto px-0 col-12">
            <TrackSurveyMember />
          </div>
        </div>
        <div v-if="activeTab === 4" class="tab-pane show active">
          <div class="border-0 mx-auto px-0 col-12">
            <GenerateTestData />
          </div>
        </div>
        <div v-if="activeTab === 5" class="tab-pane show active">
          <div class="border-0 mx-auto px-0 col-12">
            <Maintenance tablename="g_checklistitems" />
          </div>
        </div>
        <div v-if="activeTab === 6" class="tab-pane show active">
          <div class="border-0 mx-auto px-0 col-12">
            <Maintenance tablename="g_addon_surveys" />
          </div>
        </div>
        <div v-if="activeTab === 7" class="tab-pane show active">
          <div class="border-0 mx-auto px-0 col-12">
            <AddonSurveyExport />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import Maintenance from './Maintenance';
import ConsultantLegacyImport from './ConsultantLegacyImport';
import GetBrowser from './GetBrowser.vue';
import TrackSurveyMember from './TrackSurveyMember.vue';
import GenerateTestData from './GenerateTestData.vue';
import Navbar from './Navbar.vue';
import Breadcrumb from './Breadcrumb.vue';
import AddonSurveyExport from './AddonSurveyExport.vue';

export default {
  name: 'GDQUtils',
  mounted() {
  },
  components: {
    Maintenance,
    ConsultantLegacyImport,
    GetBrowser,
    TrackSurveyMember,
    GenerateTestData,
    Navbar,
    Breadcrumb,
    AddonSurveyExport,
  },
  data: function() {
    return {
      activeTab: 0,
    }
  },
  methods: {
  },
}
</script>
<style>
</style>
